import {
  generateKey,
  DomainAPI,
  Channel,
  APIKey,
  getHeader,
} from "../utils/setting";
const setting = {
  state: {
    setting: {
      currencyCode: "VND",
      defaultCountryCode: null,
    },
    version: ''
  },
  reducers: {
    setState(state, payload) {
      this.state = { ...state, ...payload };
      return { ...this.state };
    },
  },
  effects: (dispatch) => ({
    getSettings(payload, rootState) {
      const _this = this;
      let url = DomainAPI + Channel + "/api/public/settings/get";

      return fetch(url, {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          [APIKey]: generateKey(),
        },
      })
        .then((res) => res.json())
        .then((result) => {
          if (result.code && result.data) {
            _this.setState({ setting: result.data });
            if (result.data.defaultCountryCode && rootState.user.user) {
              rootState.user.user.countryCode = result.data.defaultCountryCode;
            }
          }
          return result.code === 1 ? true : false;
        })
        .catch((error) => {
          return false;
        });
    },
    getVersion(payload, rootState) {
      const _this = this;
      let url = DomainAPI + Channel + "/api/public/settings/getVersion";

      return fetch(url, {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          [APIKey]: generateKey(),
        },
      })
        .then((res) => res.json())
        .then((result) => {
          if (result && result.code == 1) {
            this.setState({ version: result.data })
          }
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    updateSettings(payload, rootState) {
      let url = DomainAPI + Channel + "/api/secure/settings/updateSetting";

      return fetch(url, {
        method: "post",
        headers: getHeader(true, rootState.user.token),
        body: JSON.stringify(payload.data),
      })
        .then((res) => res.json())
        .then((result) => {
          return result;
        })
        .catch((error) => {
          return false;
        });
    },
    getIpAddress(payload = {}, rootState) {
      let url = `https://api.ipify.org/?format=json`;
      const _this = this;
      return fetch(url, {
        method: "GET",
      })
        .then((res) => res.json())
        .then((res) => {
          _this.setState({ ipAddress: res.ip });
        })
        .catch((err) => {
          console.log(err);
        });
    },
  }),
};

export default setting;
